import script from "./WelcomeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeBanner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__